import OneImage from '../../../../assets/OneImage.png'
import styled from "@emotion/styled"

const ButtonContainer =styled.div({
    width:'27px',
    height:'27px',
    display:'flex',
   justifyContent:'center',
   alignItems:'center',

})


const Button =styled.button({
    display:'flex',
    width:'100%',
    height:'100%',
    background:'none',
    border:'none'
 })

export default function MultipleImagesButton({Singlemode}){

    return(
          <ButtonContainer>
            <Button type="button" onClick={Singlemode}>
                <img src={OneImage} alt='' />
            </Button>
          </ButtonContainer>
 
     
    )
}
